<template>
  <div>
    <history-modal-content></history-modal-content>
    <div class="d-flex justify-content-end">
      <div class="d-flex justify-content-between button-group">
        <b-button v-if="currentRoutePermissions.change_lot" class="btn" @click="completeLots" variant="secondary"
                  size="sm">
          {{$t('buttons.lots.complete_lot_and_spec')}}
        </b-button>
        <b-button v-if="currentRoutePermissions.change_lot" class="btn" @click="openProlongLotModal" variant="primary"
                  size="sm">
          {{$t('buttons.lots.prolong_lot_and_spec')}}
        </b-button>
        <b-button v-if="currentRoutePermissions.change_lot" class="btn" variant="warning" @click="createRequest"
                  size="sm">
          {{$t('buttons.requests.create_request')}}
        </b-button>
        <b-button v-if="currentRoutePermissions.change_lot" class="btn" variant="success" @click="createPurchaseOrder"
                  size="sm">
          {{$t('buttons.lots.create_purchase_order')}}
        </b-button>
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </div>
      <b-modal ref="editLotModal"
               size="sm"
               ok-only
               title="Prolong lot"
               ok-title="Save"
               @ok="ProlongLot"
               ok-variant="success"
               :no-close-on-backdrop="true"
      >
        <b-row>
          <b-col>
            <label>{{$t('labels.lots.lots')}}</label>
            <multiselect v-model="lotsProlongData.lots" :max-height="200"
                         placeholder="Choose contract type"
                         :options="lotsProlongData.lots" :multiple="true"
                         :disabled="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.delivery_date')}}</label>
            <datepicker v-model="lotsProlongData.date_delivery" lang="en"
                        :class="{ required: (!lotsProlongData.date_delivery) }"
                        :not-before="currentDate" :first-day-of-week="1"
            ></datepicker>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.common.smart_search')}}
              <b-badge size="sm" variant="primary" id="smartSearchPopover">i</b-badge>
              <b-popover target="smartSearchPopover" triggers="hover focus">
                <template slot="title">Smart Search Instruction</template>
                Filter format:<strong> *[T] [W] [L] [Supplier] [Delivery term] [Humidity] </strong>,where<br>
                <strong> * </strong>
                - optional parameter that find lots sizes by inclusion of both boundaries in a given range.<br>
                <strong>[T]</strong> – lot thickness, can be single value or range<br>
                <strong>[W]</strong> – lot width, can be single value or range<br>
                <strong>[L]</strong> – lot length, can be single value or range<br>
                <strong>[Humidity]</strong>
                – lot humidity, can be single value or range. To find lots by humidity parameter “%” is necessary.<br>
                Order of sizes is mandatory –<strong> T, W, L;</strong>
                order of other parameters is optional. All matching is case insensitive.
                <strong>Examples:</strong>
                <em>45 95 2400 osipovichi 12%
                  45 95 2400 20-50%<br>
                  *45-50 92-100 2400-3600 2019-06-31
                  45-50 95 2019-06-31 Begoml</em>
              </b-popover>
            </label>
            <input class="form-control" v-model="searchData.description" @keyup.enter="search"
                   placeholder="">
          </b-col>
          <b-col>
            <label>{{$t('labels.common.supplier')}}</label>
            <multiselect v-model="searchData.shipper" :max-height="200"
                         placeholder="Choose supplier" label="name" track-by="id"
                         :options="suppliers" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.lots.lot_status')}}</label>
            <multiselect v-model="searchData.status" :max-height="200"
                         placeholder="Choose status"
                         :options="lotStatuses"
                         :taggable="true" :close-on-select="true"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.quality')}}</label>
            <multiselect v-model="searchData.quality" :max-height="200"
                         placeholder="Choose quality" label="name" track-by="id"
                         :options="qualities_list" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.humidity')}}</label>
            <multiselect v-model="searchData.humidity" :max-height="200"
                         placeholder="Choose humidity"
                         :options="humidity_list" :multiple="true"
                         :taggable="true" :close-on-select="false"></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.delivery_date')}}</label>
            <range-date-picker v-model="searchData.delivery_term" range lang="en"
                               range-separator="/" :first-day-of-week="1"></range-date-picker>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
         :aria-expanded="showCollapse ? 'true' : 'false'"
         aria-controls="collapse">
      <h3>
        {{$t('labels.common.advanced_search')}}
      </h3>
      <div class="icons-wrapper">
        <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
        <icon name="angle-right" class="angle" v-else></icon>
      </div>
    </div>
    <b-collapse id="collapse" v-model="showCollapse">
      <div class="search-form">
        <div class="search-form__filters">
          <b-row class="d-flex justify-content-between">
            <b-col cols="1">
              <label>{{$t('labels.contracts.contract_number')}}</label>
            </b-col>
            <b-col cols="2">
              <multiselect v-model="searchData.contract_id" :max-height="200"
                           placeholder="Choose contracts" label="contract_nr" track-by="id"
                           :options="contractsList" :multiple="true"
                           :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.wood')}}</label>
            </b-col>
            <b-col cols="2">
              <multiselect v-model="searchData.wood" :max-height="200"
                           placeholder="Choose wood" label="name" track-by="id"
                           :options="wood" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.thickness')}}</label>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.thickness_nominal_from" @keyup.enter="search"
                     placeholder="from" v-replace-with-positive>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.thickness_nominal_to" @keyup.enter="search"
                     placeholder="to" v-replace-with-positive>
            </b-col>
          </b-row>
          <b-row class="d-flex justify-content-between">
            <b-col cols="1">
              <label>{{$t('labels.lots.lot_or_spec_number')}}</label>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.lot_nr" @keyup.enter="search"
                     placeholder="lot number...">
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.currency')}}</label>
            </b-col>
            <b-col cols="2">
              <multiselect v-model="searchData.currency" :max-height="200"
                           placeholder="Choose currency" label="code" track-by="id"
                           :options="currencies" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.width')}}</label>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.width_nominal_from" @keyup.enter="search"
                     placeholder="from" v-replace-with-positive>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.width_nominal_to" @keyup.enter="search"
                     placeholder="to" v-replace-with-positive>
            </b-col>
          </b-row>
          <b-row class="d-flex justify-content-between">
            <b-col cols="1">
            </b-col>
            <b-col cols="2">
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.transport')}}</label>
            </b-col>
            <b-col cols="2">
              <multiselect v-model="searchData.delivery_method" :max-height="200"
                           placeholder="Choose transport" label="name" track-by="id"
                           :options="delivery_methods" :multiple="true"
                           :taggable="true" :close-on-select="false"></multiselect>
            </b-col>
            <b-col cols="1">
              <label>{{$t('labels.common.length')}}</label>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.length_nominal_from" @keyup.enter="search"
                     placeholder="from" v-replace-with-positive>
            </b-col>
            <b-col cols="2">
              <input class="form-control" v-model="searchData.length_nominal_to" @keyup.enter="search"
                     placeholder="to" v-replace-with-positive>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-collapse>
    <div>
      <b-row>
        <b-modal ref="selectedRowsModal"
                 :title="selectedRowsModalTitle"
                 @ok="removeRowSelection"
                 ok-title="Remove lot"
                 ok-variant="danger"
                 ok-only
                 :no-close-on-backdrop="true"
        >
          <ag-grid-vue class="ag-theme-balham grid"
                       :gridOptions="selectedRowsGridOptions"
                       :columnDefs="columns"
                       :rowData="selectedRows"
                       :pinnedBottomRowData="[]"
                       :postProcessPopup="postProcessPopup"
          >
          </ag-grid-vue>
        </b-modal>
        <b-col cols="4">
          <input class="form-control"
                 placeholder="Filter..."
                 @input="setQuickFilter">
        </b-col>
        <b-col cols="4" offset="4" class="vertical-center-container d-flex justify-content-end">
          <save-columns-btn :grid="gridOptions" :grid-name="gridName" class="margin-right-5"></save-columns-btn>
          <b-button class="btn" variant="secondary" @click="showSelectedRows">
            {{$t('buttons.lots.show_selected_lots')}}
            <b-badge variant="danger">
              {{selectedRowsCount}}
            </b-badge>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham grid" :gridOptions="gridOptions" :style="gridHeight"
                       :columnDefs="columns" :rowData="lots" :pinnedBottomRowData="pinnedRowData"
                       @rowDataChanged="countSelectedRows" @rowSelected="countSelectedRows"
                       :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-col>
      </b-row>
      <b-row class="pagination__wrapper">
        <b-col cols="5">
          <div class="pagination-info">{{countOfViewLots}} {{$t('common_content.of')}} {{lotsCount}}
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import {
    mapGetters,
    mapState
  } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import RangeDatePicker from 'vue2-datepicker';
  import HistoryModalContent from '@/components/modals/HistoryModal';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import Datepicker from 'vue2-datepicker';
  import moment from 'moment';
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      RangeDatePicker,
      Datepicker,
      HistoryModalContent,
      SaveColumnsBtn,
      'ag-grid-vue': AgGridVue
    },
    data() {
      return {
        selectedRows: [],
        selectedRowsCount: 0,
        showCollapse: false,
        lotsProlongData: {
          lots: [],
          date_delivery: ''
        },
        searchData: {
          description: '',
          wood: [],
          quality: [],
          status: 'active',
          humidity: [],
          delivery_term: '',
          contract_id: [],
          thickness_nominal_from: '',
          thickness_nominal_to: '',
          width_nominal_from: '',
          width_nominal_to: '',
          length_nominal_from: '',
          length_nominal_to: '',
          delivery_method: [],
          lot_nr: '',
          shipper: [],
          currency: []
        },
      }
    },
    methods: {
      search() {
        const searchObject = {
          ...this.searchData,
          wood: getArrayByProperty(this.searchData.wood, 'id').toString(),
          quality: getArrayByProperty(this.searchData.quality, 'id').toString(),
          currency: getArrayByProperty(this.searchData.currency, 'id').toString(),
          contract_id: getArrayByProperty(this.searchData.contract_id, 'id').toString(),
          delivery_term_between_after: this.searchData.delivery_term && this.searchData.delivery_term[0] ? moment(this.searchData.delivery_term[0]).format(DATE_FORMAT) : '',
          delivery_term_between_before: this.searchData.delivery_term && this.searchData.delivery_term[1] ? moment(this.searchData.delivery_term[1]).format(DATE_FORMAT) : '',
          shipper: getArrayByProperty(this.searchData.shipper, 'id').toString(),
          humidity: this.searchData.humidity.toString(),
          delivery_method: getArrayByProperty(this.searchData.delivery_method, 'id').toString()
        };
        this.$store.dispatch('lots/loadLots', searchObject);
        saveFilters('purchaseLots', this.searchData);
      },
      createPurchaseOrder() {
        if (this.selectedRows.length) {
          const id = getArrayByProperty(this.selectedRows, 'id');
          this.$http.post(`purchase/lots/create_order/`, {id})
            .then(handlerResponse).then((response) => {
            this.$router.push({path: `/purchaseOrders/${response}`});
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$notify(setNotifyData('', 'Select at least one lot to create purchase order.', 'error'));
        }
      },
      createRequest() {
        if (this.selectedRows.length) {
          const id = getArrayByProperty(this.selectedRows, 'id');
          this.$http.post(`purchase/request_items/create_request_order/`, {id})
            .then(handlerResponse).then((response) => {
            this.$router.push({path: `/requests/${response}`});
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$notify(setNotifyData('', 'Select at least one lot to create request order.', 'error'));
        }
      },
      completeLots() {
        if (this.selectedRows.length) {
          const completesearchData = getArrayByProperty(this.selectedRows, 'id').map((e) => {
            return {
              'id': e,
              'status': 'completed'
            }
          });
          this.$http.put('purchase/lots/', completesearchData).then(() => {
            this.search();
            this.$notify(setNotifyData('Success', 'Lot information has been saved', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        } else {
          this.$notify(setNotifyData('', 'Choose at least one lot!', 'error'));
        }
      },
      openProlongLotModal() {
        this.lotsProlongData.lots = getArrayByProperty(this.selectedRows, 'lot_nr');
        if (this.lotsProlongData.lots.length) {
          this.lotsProlongData.date_delivery = '';
          this.$refs['editLotModal'].show();
        } else {
          this.$notify(setNotifyData('', 'Choose at least one lot for edit', 'error'));
        }
      },
      ProlongLot(event) {
        if (!this.lotsProlongData.date_delivery) {
          event.preventDefault();
          this.$notify(setNotifyData('', 'Enter required fields', 'error'));
        } else {
          const data = getArrayByProperty(this.selectedRows, 'id').map((e) => {
            return {
              status: 'active',
              id: e,
              delivery_term: moment(this.lotsProlongData.date_delivery).format(DATE_FORMAT)
            }
          })
          this.$http.put('purchase/lots/', data).then(() => {
            this.search()
            this.$notify(setNotifyData('Success', 'Lot information has been saved', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        }
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      setQuickFilter(e) {
        this.gridOptions.api.setQuickFilter(e.target.value);
      },
      showSelectedRows() {
        this.$refs['selectedRowsModal'].show();
      },
      countSelectedRows(event) {
        if (event.type === 'rowSelected' && event.node.selected) {
          if (!this.selectedRows.find(e => e.id === event.data.id)) {
            this.selectedRows.push(event.data);
          }
        } else {
          this.selectedRows = this.selectedRows.filter(e => e !== event.data)
        }
        this.selectedRowsCount = this.selectedRows.length;
      },
      removeRowSelection(event) {
        event.preventDefault();
        this.selectedRowsGridOptions.api.getSelectedRows().forEach((removedRow) => {
          this.selectedRows = this.selectedRows.filter(selectedRow => selectedRow !== removedRow)
        });
        this.selectedRowsCount = this.selectedRows.length;
        const deselectedRowsId = getArrayByProperty(this.selectedRowsGridOptions.api.getSelectedRows(), 'id');
        this.gridOptions.api.forEachNode((node) => {
          if (deselectedRowsId.includes(node.data.id)) {
            node.setSelected(false);
          }
        });
      },
      clearData() {
        this.$store.commit('lots/setData', []);
      }
    },
    beforeMount() {
      this.$store.cache.dispatch('woodware/getWood');
      this.$store.cache.dispatch('woodware/getQualitiesList');
      this.$store.cache.dispatch('woodware/getDeliveryMethods');
      this.$store.dispatch('woodware/loadHumidityList');
      this.$store.dispatch('generic/getCurrencies');
      this.$store.dispatch('partners/getSuppliers');
      this.$store.dispatch('contracts/loadContractsList');
      if (checkSavedFilterData('purchaseLots')) {
        this.searchData = setFilters('purchaseLots');
        this.search();
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    },
    computed: {
      ...mapState('lots', ['gridName']),
      ...mapState('generic', ['currencies', 'currentRoutePermissions']),
      ...mapGetters('lots', {
        gridOptions: 'gridOptions',
        selectedRowsGridOptions: 'selectedRowsGridOptions'
      }),
      ...mapState('lots', ['columns', 'lots', 'lotsCount', 'lotStatuses', 'pinnedRowData']),
      ...mapState('woodware', ['wood', 'qualities_list', 'delivery_methods', 'humidity_list']),
      ...mapState('partners', ['suppliers']),
      ...mapState('contracts', ['contractsList']),
      countOfViewLots() {
        return this.lots.length;
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 505px)'} : {height: 'calc(100vh - 365px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 365px)'};
        }
      },
      currentDate() {
        return new Date();
      },
      selectedRowsModalTitle() {
        return `${this.$i18n.t('modal_dialogs.selected_lots')}`
      }
    }
  }
</script>

<style scoped>

  .grid {
    height: 500px;
  }

  .counter {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/purchases/lots/PurchaseLotsList.vue